<template>
  <div>
    <Cal />
  </div>
</template>

<script>
import api from "@/api";

export default {
  components: {},
  data() {
    return {
      value: 1,
      value2: 1,
    };
  },
  created() {},
};
</script>

<style scoped lang="scss"></style>
